import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import _ from 'lodash';

import Icon from 'src/components/Icon/Icon';
import { RootState } from 'src/configs/store';
import TypeCodes from 'src/components/HorseBetting/FastMode/TypeCodesModal/TypeCodes';
import DraggableDialog from 'src/components/DraggableDialog/DraggableDialog';
import useIsMobile from 'src/hooks/useIsMobile';
import { LocationInterface, RouterInterface } from 'src/interfaces/RouterInterface';
import { Radio, FormControlLabel } from '@material-ui/core';


interface SportBetCodeProps {
  productType: number
}

export default function SportBetCodeSearch({ productType } : SportBetCodeProps) {
  const [codes, setCodes] = useState({ fixtures:'', outcomes:'' });
  const [showModal, setShowModal] = useState(null);
  const location:LocationInterface = useSelector<RouterInterface>(state => state.router);

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const mobile = useIsMobile();

  const { cardCodeErrors, cardCodes } = useSelector((state: RootState)  => state.events);
  const { typeOfCode } = useSelector((state: RootState)  => state.peripherals);

  const checkIfValidInput =(type :string) => {
    // WILL BE RE-ADDED AS SOON AS WE HAVE BE FUNCTIONALITY
    if (type){
      return true;
    } else {
      return true;
    }
    // const code =  /\b(?=(?:[1-9]*[A-I]){0,4}(?![1-9]*[A-I]))(?=(?:[A-I]*[1-9]){0,4}(?![A-I]*[1-9]))[A-I1-9]+\b/.test(codes[type]);
    // const checkIfRepeated = _.uniq(codes[type]).length !== codes[type].length;

    // if (!code || codes[type].length > 8 || checkIfRepeated){
    //   dispatch.events.changeCardCodeError(`invalidFormat${ type }`);
    // }

    // if (type === 'outcomes' && codes.fixtures === '') {
    //   dispatch.events.changeCardCodeError('invalidFixture');
    // }
  };

  const cleanErrors = (e=null) => {
    if (e){
      e.preventDefault();
    }

    setCodes({ fixtures: '', outcomes:'' });
    dispatch.events.changeCardCodeError('');
  };

  const changeTypeCode = (code) => {
    dispatch.peripherals.changeTypeOfCode(code);
    cleanErrors();
  };

  const getTitle = () => {
    let title = t('racingDetail.retailBetCodesTitle');

    if (productType === 1 && showModal === 'cardCodes'){
      title = t('typeCodes.cardCodesSportTitle');
    } else if (productType === 2 && showModal === 'cardCodes'){
      title = t('typeCodes.cardCodesHorseTitle');
    } else if (productType === 4 && showModal === 'betCodes'){
      title = t('typeCodes.betCodesLottoTitle');
    } else if (productType === 4 && showModal === 'cardCodes'){
      title = t('typeCodes.cardCodesLottoTitle');
    } else if (productType === 1 && showModal === 'betCodes'){
      title = t('typeCodes.betCodesSportTitle');
    }
    return title;
  };

  useEffect(() => {

    if (location.action === 'PUSH'){
      dispatch.events.changeCardCodeEvent(false);
      dispatch.events.changeCardCodeError('');
      dispatch.events.changeCardCodes({ fixtures:'', outcomes:'' });
      dispatch.events.resetSearchResults();
    } else {
      setCodes(cardCodes);
    }

  }, []);

  useEffect(() => {
    if (codes.fixtures){
      checkIfValidInput('fixtures');
    }
    if (codes.outcomes){
      checkIfValidInput('outcomes');
    }
  }, [codes]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    const eventInfo = await dispatch.events.searchBetCode({
      code:codes.fixtures, productType,
      betCode: codes.outcomes === '' ? null :codes.outcomes });
    dispatch.events.changeCardCodes(codes);

    if (eventInfo && _.size(eventInfo) > 1 && productType === 1){
      await dispatch.betslip.addBet({ ...eventInfo, fixtureCode: codes.fixtures, betCode: codes.outcomes });
      setCodes({ ...codes, outcomes:'' });
      dispatch.events.changeSearch(codes.fixtures);

    } else if (eventInfo && _.size(eventInfo) > 1 && productType === 2) {
      const info = await dispatch.events.racingBetCodeSearch({ productType: 2, race: 0, couponCard: codes.fixtures, betType: codes.outcomes });
      if (info && codes.outcomes !== ''){
        dispatch.events.changeCardCodeError(info);
      }

      return ;
    } else if (eventInfo && _.size(eventInfo) === 1){
      dispatch.events.changeCardCodeError(t('invalidOutcome'));
    } else {
      dispatch.events.changeCardCodeError(t('invalidFixture'));
    }

    if (productType === 1 && eventInfo){
      dispatch.events.getSearchResults({ q: null, product: 'sports' });
      dispatch.events.changeSearch(codes.fixtures);
      await dispatch.events.searchByEventCode({ code: eventInfo?.eventCode || null });
      dispatch.events.changeCardCodeEvent(true);
    }
  };

  const handleChange = (e) => {
    e.preventDefault();

    setCodes({ ...codes, [e.target.name]: e.target.value.toUpperCase() });
    dispatch.events.changeCardCodeError('');
  };

  const handleRadioChange = (type) => {
    dispatch.lotto.resetLottoRetailValues();
    changeTypeCode(type);
  };

  return (
    <>
      <form onSubmit={ handleSubmit } className="code-search__form">
        <div className="code-search__radio-container">
          <FormControlLabel
            value="none"
            className="code-search__radio"
            control={
              <Radio
                color="primary"
                checkedIcon={ <Icon icon="radioButton" /> }
                icon={ <Icon icon="radioButtonOpen" /> }
                checked={ typeOfCode === 'cardCode' }
                onChange={ () => handleRadioChange('cardCode') }
                className="code-search__radio"
              />
            }
            label={ <span className="code-search__radio--label">{ t('typeOfCode.cardCode') }</span> }
          />
          <FormControlLabel
            value="none"
            className="code-search__radio"
            control={
              <Radio
                color="primary"
                checkedIcon={ <Icon icon="radioButton" /> }
                icon={ <Icon icon="radioButtonOpen" /> }
                checked={ typeOfCode === 'couponCode' }
                onChange={ () => handleRadioChange('couponCode') }
                className="code-search__radio"
              />
            }
            label={ <span className="code-search__radio--label">{ t('typeOfCode.couponCode') }</span> }
          />
        </div>
        <div className="code-search__title-container">
          <span className="code-search__title code-search__title--selectable" onClick={ () => setShowModal('cardCodes') }>
            { t('betCodeSearch.cardCode') }
          </span>
          <span
            className="code-search__title code-search__title--selectable"
            onClick={ () => setShowModal('betCodes') }
          >{ t('betCodeSearch.betCode') }</span>
        </div>
        <div className={
          classNames({
            'code-search__input-container': true,
            'code-search__input-container--error': cardCodeErrors
          })
        }
        >
          <input
            type="text"
            autoComplete="new-password"
            value={ codes.fixtures }
            placeholder={ t(`typeOfCode.${ [typeOfCode] }`) }
            onChange={ handleChange }
            name="fixtures"
            className={
              classNames({
                'code-search__input-sport' : true,
                'code-search__input-sport--error': cardCodeErrors === 'invalidFixture' ||
                 cardCodeErrors === 'invalidFormatfixtures'
              })
            }
          />
          <input
            type="text"
            value={ codes.outcomes }
            autoComplete="new-password"
            onChange={ handleChange }
            placeholder={ typeOfCode !== 'couponCode'? t('betCodeSearch.betCodePlaceholder') :  t('numbers.betCouponCodePlaceholder') }
            name="outcomes"
            className={
              classNames({
                'code-search__input-sport' : true,
                'code-search__input-sport--error': cardCodeErrors === 'invalidOutcome'
                 || cardCodeErrors === 'invalidFormatoutcomes'
              })
            }
          />
        </div>
        {
          cardCodeErrors && <Icon
            icon="trash"
            className="code-search__error-icon"
            onClick={ cleanErrors }
          />
        }
        <button
          type="submit"
          className={
            classNames({
              'code-search__button' : true,
              'code-search__button--disabled': cardCodeErrors || _.isEmpty(codes.fixtures)
            })
          }
        >
          <Icon
            icon="return"
            className={
              classNames({
                'code-search__check': true,
                'code-search__check--disabled': cardCodeErrors || _.isEmpty(codes.fixtures)
              })
            }
          />
        </button>

      </form>
      {
        cardCodeErrors && <div className="code-search__error">{
          cardCodeErrors !== 'invalidFormatfixtures' && cardCodeErrors !== 'invalidFormatoutcomes'
            ? t('betCodeSearch.error')
            :  t(`betCodeSearch.${ cardCodeErrors }`)
        } {
          cardCodeErrors !== 'invalidFormatfixtures' && cardCodeErrors !== 'invalidFormatoutcomes' &&
        <span
          onClick={ () => setShowModal(cardCodeErrors === 'invalidFixture' ? 'cardCodes' : 'betCodes') }
          className="code-search__list"
        >{ cardCodeErrors === 'invalidOutcome' ? t('betCodeSearch.betCode') : t('betCodeSearch.cardCode') }</span>
        }
        </div>
      }
      {
        showModal && (showModal === 'cardCodes' || (showModal === 'betCodes')) &&
        <DraggableDialog className="event-row__dialog" disablePortal={ mobile } placement="right-start">
          <DraggableDialog.Content>
            <TypeCodes closeModal = { () => setShowModal(null) } title= { getTitle() } >
              { showModal === 'cardCodes' && <TypeCodes.CardCodes productType={ productType } /> }
              { showModal === 'betCodes' && productType === 2 && <TypeCodes.HorseMarket /> }
              { showModal === 'betCodes' && productType === 4 && <TypeCodes.NumberCodes /> }
              { showModal === 'betCodes' && productType === 1 && <TypeCodes.SportMarket /> }
            </TypeCodes>
          </DraggableDialog.Content>
        </DraggableDialog>
      }
    </>
  );
}
